var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'relative',
    'flex',
    'space-x-0 xs:space-x-2',
    'rtl:space-x-reverse',
    'justify-end',
    'items-center',
    _vm.isStream ? 'h-10 ltr:pr-2 rtl:ml-2' : 'h-[38px] ltr:pr-1.5 rtl:pl-1.5' ]},[_c('OzContainedButton',{attrs:{"size-preset":_vm.OzContainedButtonSizePreset.H24px,"color-scheme":_vm.OzContainedButtonColorScheme.SecondaryClear,"dark-mode":_vm.colorScheme === 'dark',"text":_vm.__('Remove')},on:{"click":function($event){$event.stopPropagation();return _vm.deletePost($event)}}}),_vm._v(" "),_c('OzContainedButton',{attrs:{"size-preset":_vm.OzContainedButtonSizePreset.H24px,"dark-mode":_vm.colorScheme === 'dark',"text":_vm.__('Approve')},on:{"click":function($event){$event.stopPropagation();return _vm.approve($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }